module.exports = __webpack_public_path__ + "static/media/video-preview@2x.167f32ed.jpg";